<section class="component-container">
  <div class="search-container">
    <div class="group-container" *ngFor="let group of searchFormConfigParams?.groups">
        <span *ngIf="group.title" class="title">{{group.title}}</span>
        <div class="toggle-panel" *ngFor="let field of group.fields">
          <gen-toggle-switch name=field.name [active]=field.default [ngClass]="field.name"
                             (statusUpdate)="toggleSelection($event, field.name)"></gen-toggle-switch>
          <label class="item-text">{{field.label}}</label>
        </div>
    </div>

    <div class="search-panel">
      <span class="title">Search string:</span>
      <span class="search-text">{{searchParamsStr}}</span>
      <gen-button class="search-button"
                  (click)="searchClicked($event)"
                  [type]="'primary'"
                  [text]="buttonText"
      ></gen-button>
    </div>
  </div>
</section>